import { faRotateRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIcon } from '@mantine/core'
import { MapContext } from 'App/Map/MapContext/MapContext'
import { useContext, useEffect } from 'react'
import { colors } from 'settings/colors'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { loadDataFromUserAppStartup } from '../../Map/_utils/loadAppStartupData/loadDataFromUserAppStartup'
import { networkStore } from '../store/networkStore'
import { loadMapData } from '../utils/loadStartupData'

export const ReloadMapButton = () => {
  const { setLoadingData, loadingData } = useContext(MapContext)
  const selectedPropertyId = selectedFieldAssetsStore.useSelector((s) => s.property)
  const connected = networkStore.useSelector((s) => s.connectionStatus.connected)

  useEffect(() => {
    // prevent icon from stuck in spinning when connection is lost while downloading data
    if (!connected) setLoadingData(false)
  }, [connected])

  const handleClick = async () => {
    if (!connected) return

    setLoadingData(true)

    await Promise.all([
      selectedPropertyId && loadMapData([selectedPropertyId]),
      // Reload user properties & profile data
      loadDataFromUserAppStartup(),
    ])

    setLoadingData(false)
  }

  return (
    <ActionIcon
      loading={loadingData}
      onClick={handleClick}
      size="xl"
      radius="xl"
      variant="outline"
      style={{
        color: !connected ? colors.gray : colors.primary,
        backgroundColor: colors.grey50,
      }}
      disabled={!connected}
    >
      <FontAwesomeIcon icon={faRotateRight} />
    </ActionIcon>
  )
}
